<template>
  <CFooter :fixed="false">
    <div>
      <span>Administracion</span>
      <span class="ml-1">WEB</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Creado por</span>
      <span>Yo</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
